<div id="viewerControls" class="viewer-controls-wrapper">
  <div class="logo-wrapper">
    <!-- Student doesn't need this as they already have a header.
     Check to render is within the logo wrapper to maintain spacing when logo not shown.
    -->
    @if (!isInsideIframe) {
      @if (isHighlights) {
        <img class="appLogo"
             src="assets/img/highlights.svg"
             alt="highlights logo"
             role="presentation"
        />
      } @else {
        <img class="appLogo"
             src="assets/img/zb-icon-white.svg"
             alt="zb logo"
             role="presentation"
        />
      }
    }

  </div>

  <div class="button-group exit-control" id="exit-control">
    <div class="back-group w-100">
      <!-- On desktop, back button is on left side in control pane. CSS shows/hides this. -->
      <zbp-viewer-back-button
        [isInsideIframe]="isInsideIframe"
        [isActivityComplete]="isActivityComplete">
      </zbp-viewer-back-button>
      <div class="viewer-control-separator"></div>
    </div>
  </div>

  @if (viewerConfiguration?.includeNavigation) {
    <div class="button-group navigation-button-group">
      <zbp-viewer-navigation-toggle
        [navToggle]="asset?.navigationToggles"
        [pageInfo]="asset?.pageInfo"
        (pageChanged)="pageChanged()"
      />
      <div class="viewer-control-navigation-separator-mobile"></div>
    </div>
  }

  <div class="viewer-asset-controls" #assetControls>
    @if (viewerConfiguration?.includeAudio) {
      <div class="button-group">
        <div id="assetNavigation" class="h-auto assetNavigation w-100"
             [class.assetNavigationCompressed]="zoomLevel > 100">
          <zbp-viewer-audio-player
            [assetIds]="asset?.relatedAudio"
            [assetList]="viewerAssets"
            [isDesktop]="isDesktop"
          ></zbp-viewer-audio-player>
          <div class="viewer-control-separator viewer-control-separator-desktop-only"></div>
        </div>
      </div>
    }

    @if (viewerConfiguration?.includeZoom || viewerConfiguration?.includeDigitalInk || viewerConfiguration?.includePrint) {
      @if (viewerConfiguration?.includeZoom) {
        <div class="zoomControl">
          <zbp-viewer-zoom
            #viewerZoomComponent
            (activeZoomTool)="setActiveZoomTool($event)"
            (zoomPercent)="setZoomPercent($event)"
            [zoomMin]="viewerConfiguration?.zoomMin"
            [zoomMax]="viewerConfiguration?.zoomMax"
            [zoomIncrement]="viewerConfiguration?.zoomIncrement"
            [isDesktop]="isDesktop"
          ></zbp-viewer-zoom>
        </div>
        <div class="viewer-control-separator viewer-control-separator-desktop-only"></div>
      }
      @if (viewerConfiguration?.includePrint) {
        <zbp-viewer-print (triggerPrint)="printImage()"></zbp-viewer-print>
        <div class="viewer-control-separator viewer-control-separator-desktop-only"></div>
      }
      @if (viewerConfiguration?.includeDigitalInk) {
        <div class="inkControl">
          <zbp-viewer-draw
            [enabled]=viewerConfiguration?.enableDigitalInk
            (activeDrawingTool)="setActiveDrawingTool($event)"
            [isDesktop]="isDesktop"
            (clearDrawing)="clear()"
            (activeColor)="setActiveColor($event)"
            (activeSize)="setActiveSize($event)"
          >
          </zbp-viewer-draw>
          <div class="viewer-control-separator viewer-control-separator-desktop-only"></div>
        </div>
      }
    }

    @if (viewerConfiguration?.includeAdditionalInfo && asset?.additionalInfo) {
      <zbp-viewer-additional-info
        [asset]="asset"
        [isDesktop]="isDesktop"
      />
      <div class="viewer-control-separator viewer-control-separator-desktop-only"></div>
    }

    <zbp-button-component id="fullScreenButton"
                          [theme]="'viewerControl'"
                          [borderRadius]="'0'"
                          [label]="isFullScreen ? 'Exit Fullscreen' : 'Enter Fullscreen'"
                          [ariaLabel]="isFullScreen ? 'Exit Fullscreen' : 'Enter Fullscreen'"
                          [iconPosition]="'top'"
                          [iconName]="isFullScreen ? zbpIconNames.minimizeIcon : zbpIconNames.maximizeIcon"
                          [customClass]="'viewer-asset-control-button'"
                          (clickHandler)="toggleFullScreen()"
    >

    </zbp-button-component>


    @if (!userService.isMasqueraded && !isHighlights
    && (userService.user.isTeacher || userService.user.isSchoolAdmin || userService.user.isDistrictAdmin)) {
      <div class="feedback-button-and-separator">
        <div class="viewer-control-navigation-separator-mobile"></div>
        <div class="button-group navigation-button-group feedback-button">
          <zbp-button-component id="feedbackButton"
                                theme="viewerControl"
                                label="Feedback"
                                ariaLabel="Feedback"
                                [iconName]="zbpIconNames.megaphoneIcon"
                                iconPosition="top"
                                (clickHandler)="openFeedbackForm()"
          ></zbp-button-component>
        </div>
      </div>
    }

    @if (isLessonNavigation) {
      <div class="feedback-button-and-separator">
        <div class="viewer-control-navigation-separator-mobile"></div>
        <div class="button-group navigation-button-group feedback-button">
          <zbp-viewer-lesson-materials
            [isDesktop]="isDesktop"
            [lessonSteps]="lessonSteps"
          />
        </div>
      </div>
    }
  </div>

</div>
